import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as eventServices from "../services/eventService"
import GameBox from './sub_components/gamebox'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import Header from './header'
import Menu from './menu'
import { SPECIFICCOMPETITIONID } from '../configs/commonConfigs';
let socket = null
export default class SpecificCompetitionGameList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: [],
            gameCode: "4",
            pinnedEvents: [],
            loading: true,
            mktFeedBooks: {},
            subscribedMarkets: [],
            specificCompetitionID: SPECIFICCOMPETITIONID,
            isVirtual:true
        };
    }
    parseBook(data) {
        !!data && data.length > 0 && data.forEach((mkt, i) => {
            // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
            let book = !!mkt.metadata && !!mkt.metadata.book ? JSON.parse(mkt.metadata.book) : null
            data[i].metadata = {}
            data[i].metadata.book = book
        })
        return data
    }
    async componentWillReceiveProps() {
        setTimeout(async () => {
            let homeData = localStorage.getItem("homeData")
            homeData = JSON.parse(homeData)
            if (!homeData) {
                return false
            }
            if (!homeData) {
                homeData = await eventServices.getHomeData()
                homeData = this.parseBook(homeData)
                localStorage.setItem('homeData', JSON.stringify(homeData))
            }
            
            let userEventCktData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "4"
            })
            let userEventSocData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "1"
            })
            let userEventTenData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "2"
            })
            let userEventKbdData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "400"
            })
            let userEventElcData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "500"
            })
            this.getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElcData)
        }, 100)
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.setState({ mktFeedBooks: feedBooks })
    }
    async getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElectData) {
        let userEventData = this.state.gameCode === "4" ? userEventCktData : (this.state.gameCode === "1" ? userEventSocData : (this.state.gameCode === "2" ? userEventTenData : (this.state.gameCode === "400" ? userEventKbdData : userEventElectData)));
        let events = []
        
        if(!!userEventData && userEventData.length > 0){
            userEventData = userEventData.filter((mkt)=> mkt.competition.id === this.state.specificCompetitionID);
        }
        !!userEventData && userEventData.length > 0 && userEventData.forEach((mkt, i) => {
            if (!mkt) {
                return false
            }
            let eventIndex = events.findIndex(x => x.id === mkt.event.id)
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            market.metadata = mkt.metadata
            market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : {}
            market.marketId = mkt.catalogue.marketId
            if (Object.keys(market.marketBook).length === 0) {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }], "lay": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE" || market.marketBook.status === "INACTIVE" || !market.marketBook.runners || market.marketBook.runners.length < 2) {
                    return false
                }
            }
            if (eventIndex === -1) {
                let evt = mkt.event
                evt.isInplay = market.inPlay === true ? true : false
                evt.eventTypeId = mkt.eventType.id
                evt.eventType = mkt.eventType.name
                evt.competitionId = mkt.competition.id
                evt.compititionName = mkt.competition.name
                evt.markets = [market]
                events.push(evt)
            } else {
                events[eventIndex].isInplay = market.inPlay === true ? true : events[eventIndex].isInplay
                events[eventIndex].markets.push(market)
            }
        })
        events = events.sort((vote1, vote2) => {
            if (vote1.isInplay > vote2.isInplay) return -1;
            if (vote1.isInplay < vote2.isInplay) return 1;
            if (new Date(vote1.openDate) > new Date(vote2.openDate)) return 1;
            if (new Date(vote1.openDate) < new Date(vote2.openDate)) return -1;
            if (vote1.name > vote2.name) return 1;
            if (vote1.name < vote2.name) return -1;
            return 0;
        });

        // await this.props.actions.setHomeData([])
        // await this.props.actions.setHomeData(events)
        let game = events.filter((et) => {
            return et.eventTypeId === this.state.gameCode
        })

        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ game: [] }, () => {
            this.setState({ pinnedEvents: pinnedEvents, loading: false, game: game })
        })
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    gameTab(game) {
        this.setState({ game: game })
    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body>
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSubscribedMarkets={() => { this.updateSubscribedMarkets() }} updateSocket={(skt) => { this.updateSocket(skt) }} getEvtData={(ckt, soc, ten, kbd, elc) => { this.getEvtData(ckt, soc, ten, kbd, elc) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <div className="text-center mb-2">
                            <img alt="" src={this.state.gameCode === "4" ? BASE_IMAGE_PATH + "/casino/banner/Cricket-banner.jpg" : this.state.gameCode === "1" ? BASE_IMAGE_PATH + "/casino/banner/Soccer-banner.jpg" : this.state.gameCode === "2" ? BASE_IMAGE_PATH + "/casino/banner/Tennis-banner.jpg" : this.state.gameCode === "400" ? BASE_IMAGE_PATH + "/casino/banner/Kabaddi-banner.jpg" : BASE_IMAGE_PATH + "/casino/banner/Election-banner.jpg"} ></img>
                        </div>
                        {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && !this.state.loading && <GameBox history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} socket={socket} game={this.state.game} gameCode={this.state.gameCode} toggleMultiMarket={(eventId) => { this.toggleMultiMarket(eventId) }} pinnedEvents={this.state.pinnedEvents}/>}
                    </div>
                </div>
            </body>
        )
    }
}